import api from "../../config/client.axios.api";

export const getRevenueStoreApi = async (
  accountId: string,
  startDate: string,
  endDate: string
) => {
  const response = await api.get(`/history/get-revenue-store`, {
    params: {
      accountId: accountId && accountId,
      startDate,
      endDate,
    },
  });
  return response.data;
};
